import { FC, ReactElement } from 'react'

import { Link } from 'react-router-dom'

import { MenuItem } from '../../constants/MenuItems'
import { useSidebar } from '../../hooks/useSidebar'

type Props = {
  item: MenuItem
}

export const SidebarMobileMenuItem: FC<Props> = (props): ReactElement => {
  const {
    item: { icon: Icon, ...item },
  } = props

  const { menuSelected } = useSidebar()

  return (
    <li data-is-selected={menuSelected === item.id} className="data-[is-selected=true]:bg-accent-2 rounded-full p-4">
      <Link to={item.path}>
        <Icon
          size={24}
          data-is-selected={menuSelected === item.id}
          className="text-text-secondary data-[is-selected=true]:text-accent-1"
        />
      </Link>
    </li>
  )
}
